// 빌드: ./fe-build.sh voice
import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/ynadmin/common/common.js';
import swal from 'sweetalert';
import Editor from "./components/common/editor.vue";
import validation from 'validator';
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import Share from './components/common/share.js';
import mobile from 'is-mobile';
import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";

Vue.use(VueFileAgent);
Vue.use(mobile);

Vue.component("pager", Pager);
Vue.component('editor', Editor);
Vue.component('dropimg', DropImg);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);

Vue.prototype.$http = Axios;
Vue.prototype.$pager = Pager;
Vue.prototype.$common = Common;

new Vue({
  el: '#voice',
  data: function () {
    return {
      mainName: '청소년시민청원',
      isShare: false,
      isMobile: false,
      listBanner: [],
      inputLabel: '',
      selectVoiceSortType: '',
      selectVoiceModelType: '',
      selectYearModel: '',
      searchModel: {
        brdSubCtg: '',
        searchKeyword: '',
        searchYear: '',
        tab: '',
        brdUidKey: ''
      },
      isMobileStyle: {
        'width': '100%',
        //'height' : '250px'
        'height': 'auto'
      },
      isMobileStyles: {
        'height': 'auto'
      },
      insertVoice: {
        brdSubCtg: '',
        title: '',
        keyword: '',
        content1: '', //내용
        content2: '', //제안배경
        content3: '', //기대효과
        link: '',
        doc: ''
      },
      insertVoiceQnA: {
        name: '',
        title: '',
        keyword: '',
        hp1: '',
        hp2: '',
        hp3: '',
        email1: '',
        email2: '',
        content: ''
      },
      insertReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      insertReReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      updateReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      updateReReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      insertVoiceReport: {
        reportValue: '',
        reportEtcValue: ''
      },
      viewModel: {
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_blue',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.pager.etc;
            if (_etc == 'selectVoiceSuggestList') {
              this.model.fnGetVoiceSuggestList(this.model.viewModel.voiceTab, n);
            }
            //  else if(_etc == 'selectVoiceReplyList'){
            //     this.model.fnGetVoiceReplyList(n);
            // }
          }
        },
        boardPager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 5,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_blue',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.boardPager.etc;
            if (_etc == 'selectBoardList') {
              this.model.fnGetVoiceBoardList(this.model.viewModel.ctgFlag, n);
            }
          }
        },
        isFileTab: true,
        isQnATab: false,
        isVoiceTab: true,
        isIntroTab: true,
        isNoticeTab: false,
        isExellentTab: false,
        isLiveTab: false,
        isLike: false,
        isReport: false,
        isPrivacy: false,
        isService: false,
        isReply: false,
        isReplyUpt: false,
        isReReply: false,
        isReReplyUpt: false,
        agree: false,
        voiceAllCtg: 'all',
        voiceTab: 'likeCnt',
        ctgFlag: '',
        currReplyUidKey: '',
        hundredCount: '',
        totalCount: 1,
        totalReplyCount: 1,
        totalBoardCount: 1,
        list: [],
        detail: {},
        myProfile: {},
        codeList: [],
        sortList: [],
        yearList: [],
        hotIssueList: [],
        voiceSuggestList: [],
        replyList: [],
        replyDepthZero: [],
        replyDepthOne: [],
        voiceFileList: [],
        voiceNoticeList: [],
        reportCodeList: [],
        reportList: [],
        likeList: [],
        voiceLiveList: [],
        fileEtcList: [],
        fileImgList: [],
        fileVdList: []
      }
    }
  },
  created: function () {
    this.isMobile = mobile();
    if (!('$' in Vue.prototype) && '$' in window) {
        Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
  },
  mounted: function () {
    try {
      pageLoad(this);
      this.fnOnCheckBanner();
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    selectVoiceSortType: function (newValue, oldValue) {
      this.inputLabel = (newValue != '') ? newValue.sortName : '';
    },
    selectVoiceModelType: function (newValue, oldValue) {
      this.inputLabel = (newValue != '') ? newValue.cateNm : '';
    },
    selectYearModel: function (newValue, oldValue) {
      this.inputLabel = (newValue != '') ? newValue.yearName : '';
    }
  },
  methods: {
    fnGoVoiceMain: function () { //시민청원 메인페이지
      location.href = '/customer/voice';
    },
    fnGoVoiceSuggestInsert: function (uid) { //시민청원 정책제안 페이지
      if (uid === undefined) uid = "";
      location.href = '/customer/voice/voiceSuggestInsert?paramUid=' + uid;
    },
    fnGoVoiceSuggestMain: function (cate, tabIdx) { //시민청원 정책제안현황/Live 제안 페이지
      if (tabIdx === undefined) tabIdx = "";
      location.href = '/customer/voice/voiceSuggestMain?cate=' + cate + '&tabIdx=' + tabIdx;
    },
    fnGoVoiceFileQnaMain: function (tabIdx) { //시민청원자료실,Q&A 페이지
      location.href = '/customer/voice/voiceFileQnaMain?tabIdx=' + tabIdx;
    },
    fnGoVoiceIntroMain: function (tabIdx) { //시민청원 소개/공지/우수정책 페이지
      location.href = '/customer/voice/voiceIntroMain?tabIdx=' + tabIdx;
    },
    fnGoVoiceNoticeMain: function () { //시민청원 공지사항(백업)
      location.href = '/customer/voice/voiceNoticeMain';
    },
    fnGoVoiceDetail: function (uid) { //시민청원 상세보기
      let pageName = $("#pageName").val();
      let vm = this;

      if (pageName == 'voiceMain') {
        let order = vm.viewModel.voiceTab;

        let pageNum = vm.viewModel.pager.pageNo;

        sessionStorage.setItem("URL", "/customer/voice?order=" + order + "&pageNum=" + pageNum);
      } else if (pageName == "voiceSuggestMain") {
        let tabIdx = 0;
        let subTab = "";
        let pageNum = vm.viewModel.pager.pageNo;

        if (vm.viewModel.isVoiceTab) {
          tabIdx = 1;
          subTab = vm.viewModel.voiceTab;
        } else if (vm.viewModel.isExellentTab) {
          tabIdx = 2;
        }

        let cate = vm.searchModel.brdSubCtg;
        let searchword = vm.searchModel.searchKeyword;
        let year = (vm.selectYearModel.yearValue == null
          || vm.selectYearModel.yearValue == undefined
          || vm.selectYearModel.yearValue == "") ? "" : vm.selectYearModel.yearValue;

        sessionStorage.setItem("URL", "/customer/voice/voiceSuggestMain?cate=" + cate
          + "&tabIdx=" + tabIdx
          + "&subTab=" + subTab
          + "&year=" + year
          + "&searchword=" + searchword
          + "&pageNum=" + pageNum);
      }

      location.href = '/customer/voice/voiceDetail?paramUid=' + uid;
    },
    fnGoVoiceBoardDetail: function (uid) { //시민청원공지사항/자료실 상세보기
      location.href = '/customer/voice/voiceBoardDetail?paramUid=' + uid;
    },
    fnGoVoiceLiveTab: function (uid) { //Live 정책제안 탭 이동
      location.href = '/customer/voice/voiceLive';
    },
    fnGoVoiceLiveDetail: function (uid) { //Live 정책제안 상세보기
      location.href = '/customer/voice/voiceLiveDetail?paramUid=' + uid;
    },
    fnGoBoardInsert: function (type, uid) { //게시글(공지사항,자료실) 작성하기
      if (uid === undefined) uid = "";
      location.href = '/customer/voice/boardInsert?type=' + type + '&paramUid=' + uid;
    },
    fnOnCheckBanner: function () {
      let vm = this;
      let _param = {
        uidKey: 'BANNVLOCNV01000',
        divide: 'custommer'
      }
      let param = {
        pageNo: 0,
        pageSize: 10,
        paramText: JSON.stringify(_param)
      };

      Axios.post("/api/admin/banner/list", param).then(function (response) {
        vm.listBanner = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    /*============================================================ 조회 start ========================================================================*/
    //계열 카테고리 조회
    fnGetCodeList: function (cdGrp) {
      let vm = this;
      let param = {voiceVo: {}};
      Axios.post("/customer/voice/selectCodeList", param).then(function (response) {
        response.data.list.forEach(function (item) {
          switch (item.cateCd) {
            case 'VOICECATENV00100':
              item.cateClass = 'school';
              break;
            case 'VOICECATENV00200':
              item.cateClass = 'edu';
              break;
            case 'VOICECATENV00300':
              item.cateClass = 'job';
              break;
            case 'VOICECATENV00400':
              item.cateClass = 'club';
              break;
            case 'VOICECATENV00500':
              item.cateClass = 'volun';
              break;
            case 'VOICECATENV00600':
              item.cateClass = 'place';
              break;
            case 'VOICECATENV00700':
              item.cateClass = 'art';
              break;
            case 'VOICECATENV00800':
              item.cateClass = 'gender';
              break;
            case 'VOICECATENV00900':
              item.cateClass = 'human';
              break;
            case 'VOICECATENV01000':
              item.cateClass = 'politic';
              break;
            case 'VOICECATENV01100':
              item.cateClass = 'law';
              break;
            default:
              item.cateClass = 'etc';
          }
        });
        vm.viewModel.codeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //핫이슈 조회
    fnGetHotIssueList: function () {
      let vm = this;
      Axios.post("/customer/voice/selectHotIssueList", {voiceVo: {}}).then(function (response) {
        response.data.list.forEach(function (data) {
          if (data.fileNewName != null) {
            data.fileNewName = "/img/" + data.fileNewName.substr(0, 8) + "/" + data.fileNewName;
          }
        });
        vm.viewModel.totalCount = response.data.list.length;
        vm.viewModel.hotIssueList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //정책 조회
    fnGetVoiceSuggestList: function (tab, pageNumber) {
      let vm = this;
      vm.fnHideLikeList();
      vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;
      vm.viewModel.voiceTab = !tab ? vm.viewModel.voiceTab : tab;

      if (vm.searchModel.brdSubCtg == null || vm.searchModel.brdSubCtg == '') {
        vm.searchModel.brdSubCtg = $("#paramCate").val();
      }

      let param = {};
      param.approve = "approve";
      param.tab = vm.viewModel.voiceTab;
      param.brdSubCtg = vm.searchModel.brdSubCtg;
      param.searchKeyword = vm.searchModel.searchKeyword;
      param.searchYear = vm.selectYearModel.yearValue;
      param.pageNo = vm.viewModel.pager.pageNo;
      param.pageSize = vm.viewModel.pager.rowSize;

      Axios.post("/customer/voice/selectVoiceSuggestList", {voiceVo: param}).then(function (response) {
        if (response.data.list.length > 0) {
          response.data.list.forEach(function (item) {
            item.content1 = vm.fnOnLoadKakaoContent(item.content1);
            item.content1 = item.content1.replace(/<(\/ol|ol|\/li|li)([^>]*)>/gi, "");
          });
        }

        vm.viewModel.hundredCount = response.data.hundredCount;
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.voiceSuggestList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectVoiceSuggestList");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //정책 조회
    fnGetVoiceSuggestListEnter: function (value) {
      let vm = this;
      vm.fnHideLikeList();
      vm.viewModel.pager.pageNo = 1;

      vm.searchModel.brdSubCtg = value;

      let param = {};
      param.approve = "approve";
      param.tab = vm.viewModel.voiceTab;
      param.brdSubCtg = vm.searchModel.brdSubCtg;
      param.searchKeyword = vm.searchModel.searchKeyword;
      param.searchYear = vm.selectYearModel.yearValue;
      param.pageNo = vm.viewModel.pager.pageNo;
      param.pageSize = vm.viewModel.pager.rowSize;

      Axios.post("/customer/voice/selectVoiceSuggestList", {voiceVo: param}).then(function (response) {
        if (response.data.list.length > 0) {
          response.data.list.forEach(function (item) {
            item.content1 = vm.fnOnLoadKakaoContent(item.content1);
          });
        }

        vm.viewModel.hundredCount = response.data.hundredCount;
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.voiceSuggestList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectVoiceSuggestList");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //우수정책 조회
    fnGetVoiceExellentList: function () {
      let vm = this;

      if (vm.searchModel.brdSubCtg == null || vm.searchModel.brdSubCtg == '') {
        vm.searchModel.brdSubCtg = $("#paramCate").val();
      }
      console.log(vm.searchModel.searchKeyword);
      let param = {};
      param.approve = "approve";
      param.tab = "insertDate";
      param.cmmClsNm = 'voiceintro';
      param.brdSubCtg = vm.searchModel.brdSubCtg;
      param.searchKeyword = vm.searchModel.searchKeyword;
      param.searchYear = vm.selectYearModel.yearValue;
      param.pageNo = vm.viewModel.pager.pageNo;
      param.pageSize = vm.viewModel.pager.rowSize;

      Axios.post("/customer/voice/selectVoiceSuggestList", {voiceVo: param}).then(function (response) {
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.voiceSuggestList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectVoiceSuggestList");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //게시글 상세조회
    fnGetVoiceBoardDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/voice/selectVoiceBoardDetail", {voiceVo: param}).then(function (response) {
        vm.viewModel.detail = response.data.voiceVo;
        vm.insertVoice = vm.viewModel.detail;

        document.title = response.data.voiceVo.title;

        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });

        //온라인축제 상세보기
        if (vm.viewModel.detail.brdSubCtg == "BRDNVYTHNV00830") {
          vm.viewModel.detail.livePath = '';
          vm.viewModel.detail.livePath = '/liveVideo/' + vm.viewModel.detail.licUidKey + '.mp4'
        }

        //수정 시 selectbox 세팅
        if (vm.viewModel.codeList.length > 0) {
          vm.viewModel.codeList.forEach(function (object) {
            if (object.cateCd == vm.viewModel.detail.brdSubCtg) {
              vm.selectVoiceModelType = object;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //댓글 조회
    fnGetVoiceReplyList: function (pageNumber) {
      let vm = this;
      //vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      //param.pageNo    = vm.viewModel.pager.pageNo;
      //param.pageSize  = vm.viewModel.pager.rowSize;

      Axios.post("/customer/voice/selectVoiceReplyList", {voiceVo: param}).then(function (response) {
        vm.viewModel.totalReplyCount = response.data.depthZeroList.length;
        vm.viewModel.replyDepthZero = response.data.depthZeroList;
        vm.viewModel.replyDepthOne = response.data.depthOneList;
        //vm.fnSetPager(vm.viewModel.totalCount, "selectReplyList",vm.viewModel.pager);
        // vm.viewModel.totalCount = response.data.totalCount;
        // vm.viewModel.replyList = response.data.list;
        // vm.viewModel.replyList.forEach(function(reply){
        //     if(reply.fileNewName != null){
        //         reply.fileNewName = "/img/" + reply.fileNewName.substr(0,8) + "/" + reply.fileNewName;
        //     }
        // });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //자료실/공지사항/Live정책제안 리스트 조회
    fnGetVoiceBoardList: function (ctgFlag, pageNumber) {
      let vm = this;
      vm.viewModel.ctgFlag = ctgFlag;
      vm.viewModel.boardPager.pageNo = pageNumber ? pageNumber : 1;

      let brdSubCtg = "";
      if (ctgFlag == "file") {
        brdSubCtg = "BRDNVYTHNV00810"; //시민청원 자료실
      } else if (ctgFlag == "notice") {
        brdSubCtg = "BRDNVSUBNV00300"; //시민청원 공지사항
      } else if (ctgFlag == "live") {
        vm.viewModel.boardPager.rowSize = 6;
        brdSubCtg = "BRDNVYTHNV00830"; //시민청원 Live 정책제안
      }

      let param = {};
      param.brdSubCtg = brdSubCtg;
      param.pageNo = vm.viewModel.boardPager.pageNo;
      param.pageSize = vm.viewModel.boardPager.rowSize;

      let searchKeyword = vm.searchModel.searchKeyword.trim();
      if (searchKeyword != null && searchKeyword != "") {
        param.searchKeyword = searchKeyword;
      }

      Axios.post("/customer/voice/selectBoardList", {voiceVo: param}).then(function (response) {
        if (ctgFlag == "file") {
          vm.viewModel.voiceFileList = response.data.list;
        } else if (ctgFlag == "notice") {
          vm.viewModel.voiceNoticeList = response.data.list;
        } else if (ctgFlag == "live") {
          vm.viewModel.voiceLiveList = response.data.list;
        }

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        // vm.viewModel.fileImgList.forEach(function(file){
        //     file.fileUrl = "/img/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name;
        // });
        // vm.viewModel.fileVdList.forEach(function(file){
        //     file.fileUrl = "/video/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        // });

        vm.viewModel.totalBoardCount = response.data.totalCount;
        vm.viewModel.boardPager.etc = "selectBoardList";
        vm.viewModel.boardPager.totalSize = vm.viewModel.totalBoardCount;
        vm.viewModel.boardPager.pageNum = (vm.viewModel.boardPager.pageNo * vm.viewModel.boardPager.rowSize) - vm.viewModel.boardPager.rowSize;
        Pager.props = Pager.methods.createPager(vm.viewModel.boardPager, vm, "list");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //신고 사유 조회
    fnGetReportCodeList: function () {
      let vm = this;
      Axios.post("/customer/voice/selectReportCodeList", {voiceVo: {}}).then(function (response) {
        vm.viewModel.reportCodeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //정책 추천/신고 조회
    fnGetVoiceReportList: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      Axios.post("/customer/voice/selectVoiceReportList", {voiceVo: param}).then(function (response) {
        vm.viewModel.reportList = response.data.list;

        if (vm.viewModel.reportList != null) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100" && report.likeYn == "Y") { //좋아요
              vm.viewModel.isLike = true;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //공감한 사람 리스트 조회
    fnGetLikeList: function (brdUidKey) {
      let vm = this;
      let param = {};
      param.brdUidKey = brdUidKey;

      Axios.post("/customer/voice/selectLikeList", {voiceVo: param}).then(function (response) {
        vm.viewModel.likeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //로그인한 사람 프로필사진 조회
    fnGetMyProfile: function () {
      let vm = this;
      let param = {};

      Axios.post("/api/profile/list", param).then(function (response) {
        if (response.data.list != null) {
          if (response.data.list != null) {
            vm.viewModel.myProfile = response.data.list[0];
            vm.viewModel.myProfile.fileUrl = "/img/" + response.data.list[0].file_new_name.substr(0, 8) + "/" + response.data.list[0].file_new_name;
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    /*============================================================ 조회 end ========================================================================*/

    /*============================================================ 저장 start ========================================================================*/,
    //정책제안 작성
    fnSetVoiceSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      if (vm.selectVoiceModelType == '') {
        swal("카테고리를 입력해주세요.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.title)) {
        swal("제목을 입력해주세요.");
        return false;
      } else if (!validation.isLength(vm.insertVoice.title, 0, 200)) {
        swal("제목이 너무 깁니다.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content2)) {
        swal("배경 및 필요성을 입력해주세요.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content1)) {
        swal("내용을 입력해주세요.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content3)) {
        swal("기대효과를 입력해주세요.");
        return false;
      } else if (!vm.viewModel.agree) {
        swal("약관에 동의해주세요.");
        return false;
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.brdSubCtg = vm.selectVoiceModelType.cateCd;
      param.title = vm.insertVoice.title;
      param.content1 = vm.insertVoice.content1;
      param.content2 = vm.insertVoice.content2;
      param.content3 = vm.insertVoice.content3;
      param.keyword = vm.insertVoice.keyword;
      param.link = vm.insertVoice.link;
      param.suggest = 'suggest';

      // if($("#smlCode").val() == "USRNVYTHNV00211"){ //청소년시민청원 부서
      //     param.approve   = "approve";
      // }else{
      //     param.approve   = "ready";
      // }

      param.approve = "approve";

      vm.fnOnSwalAlert("정책제안", "등록하시겠습니까?",
        function () {
          Axios.post("/customer/voice/insertVoiceSuggest", {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '등록 완료',
                text: '등록이 완료되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },
    //정책제안 수정
    fnUptVoiceSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      if (vm.selectVoiceModelType == '') {
        swal("카테고리를 입력해주세요.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.title)) {
        swal("제목을 입력해주세요.");
        return false;
      } else if (!validation.isLength(vm.insertVoice.title, 0, 200)) {
        swal("제목이 너무 깁니다.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content2)) {
        swal("배경 및 필요성을 입력해주세요.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content1)) {
        swal("내용을 입력해주세요.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content3)) {
        swal("기대효과를 입력해주세요.");
        return false;
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.brdSubCtg = vm.selectVoiceModelType.cateCd;
      param.title = vm.insertVoice.title;
      param.content1 = vm.insertVoice.content1;
      param.content2 = vm.insertVoice.content2;
      param.content3 = vm.insertVoice.content3;
      param.keyword = vm.insertVoice.keyword;
      param.link = vm.insertVoice.link;

      vm.fnOnSwalAlert("정책제안", "수정하시겠습니까?",
        function () {
          Axios.post("/customer/voice/updateVoiceSuggest", {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '수정 완료',
                text: '수정이 완료되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },
    //정책제안 삭제
    fnDelVoiceSuggest: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = $("#paramUid").val();

      vm.fnOnSwalAlert("정책삭제", "삭제하시겠습니까?",
        function () {
          Axios.post("/customer/voice/deleteVoiceSuggest", {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },
    //문의하기
    fnSetVoiceQna: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      if (validation.isEmpty(vm.insertVoiceQnA.title)) {
        swal("제목을 입력해주세요.");
        return false;
      } else if (!validation.isLength(vm.insertVoiceQnA.title, 0, 200)) {
        swal("제목이 너무 깁니다.");
        return false;
      } else if (validation.isEmpty(vm.insertVoiceQnA.content)) {
        swal("문의사항을 입력해주세요.");
        return false;
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.title = vm.insertVoiceQnA.title;
      param.content1 = vm.insertVoiceQnA.content;

      vm.fnOnSwalAlert("문의하기", "문의하시겠습니까?",
        function () {
          Axios.post("/customer/voice/insertVoiceQna", {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '문의 완료',
                text: '문의가 등록되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  vm.fnGoVoiceFileQnaMain(1);
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },
    //댓글 작성
    fnSetReply: function (_depth, replyUidKey) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      let vm = this;
      if (_depth == 0) {
        if (validation.isEmpty(vm.insertReplyModel.replyContent)) {
          swal("댓글내용을 입력해주세요.");
          return false;
        } else if (vm.insertReplyModel.replyContent.length > 1000) {
          swal("댓글내용이 너무 깁니다.");
          return false;
        }
      } else if (_depth == 1) {
        if (validation.isEmpty(vm.insertReReplyModel.replyContent)) {
          swal("댓글내용을 입력해주세요.");
          return false;
        } else if (vm.insertReReplyModel.replyContent.length > 1000) {
          swal("댓글내용이 너무 깁니다.");
          return false;
        }
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      if (_depth == 0) {
        param.replyDepth = _depth;
        param.replyContent = vm.insertReplyModel.replyContent;
      } else if (_depth == 1) {
        param.replyDepth = _depth;
        param.replyContent = vm.insertReReplyModel.replyContent;
        param.parentsUidKey = replyUidKey;
      }

      Axios.post("/customer/voice/insertReply", {voiceVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.insertReplyModel.replyContent = "";
          vm.insertReReplyModel.replyContent = "";
          vm.fnClearReply();
          vm.fnGetVoiceReplyList();
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "Cancel",
                value: false,
                visible: false,
              },
              confirm: {
                text: "Ok",
                value: true,
                visible: true,
              },
            },
            dangerMode: true
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //댓글 수정
    fnUptReply: function (_depth, replyUidKey) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      let vm = this;
      if (_depth == 0) {
        if (validation.isEmpty(vm.updateReplyModel.replyContent)) {
          swal("댓글내용을 입력해주세요.");
          return false;
        } else if (vm.updateReplyModel.replyContent.length > 1000) {
          swal("댓글내용이 너무 깁니다.");
          return false;
        }
      } else if (_depth == 1) {
        if (validation.isEmpty(vm.updateReReplyModel.replyContent)) {
          swal("댓글내용을 입력해주세요.");
          return false;
        } else if (vm.updateReReplyModel.replyContent.length > 1000) {
          swal("댓글내용이 너무 깁니다.");
          return false;
        }
      }

      let param = {};
      if (_depth == 0) {
        param.replyUidKey = replyUidKey;
        param.replyContent = vm.updateReplyModel.replyContent;
      } else if (_depth == 1) {
        param.replyUidKey = replyUidKey;
        param.replyContent = vm.updateReReplyModel.replyContent;
      }

      Axios.post("/customer/voice/updateReply", {voiceVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.updateReplyModel.replyContent = "";
          vm.updateReReplyModel.replyContent = "";
          vm.fnClearReply();
          vm.fnGetVoiceReplyList();
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "Cancel",
                value: false,
                visible: false,
              },
              confirm: {
                text: "Ok",
                value: true,
                visible: true,
              },
            },
            dangerMode: true
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //댓글 삭제
    fnDelReply: function (replyUidKey) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.replyUidKey = replyUidKey;

      if (!confirm("삭제하시겠습니까?")) {
        return false;
      }

      Axios.post("/customer/voice/deleteReply", {voiceVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.fnGetVoiceReplyList();
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //정책 추천/신고 하기
    fnSetReport: function (kind) {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      let url = "/customer/voice/insertRecommend";

      if (kind == 'report') {
        let reportFlag = false;
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
              reportFlag = true;
            }
          });
        }
        if (reportFlag) {
          swal("이미 신고하셨습니다.");
          return false;
        } else {
          if (vm.insertVoiceReport.reportValue == null || vm.insertVoiceReport.reportValue == "") {
            swal("신고사유를 선택해주세요.");
            return false;
          }
        }
      } else if (kind == 'like') {
        if (vm.viewModel.detail.usrKey == $("#usrKey").val()) {
          swal("자신이 올린 글은 공감할 수 없습니다.");
          vm.viewModel.isLike = false;
          return false;
        }

        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100") { //좋아요
              url = "/customer/voice/updateVoiceLike";
            }
          });
        }
      }

      // if(_reason == null || _reason.trim() == ""){
      //     alert("신고사유를 선택해 주세요");
      //     return false;
      // }

      // if(_reason == 'RPTNVYTHNV00400' && vm.mentoGroupModel.reportEtcValue.trim().length == 0){
      //     alert("기타사유를 입력해 주세요");
      //     return false;
      // } else if(_reason == 'RPTNVYTHNV00400' && vm.mentoGroupModel.reportEtcValue.trim().length > 0){
      //     _reasonEtc = vm.mentoGroupModel.reportEtcValue.trim();
      // }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      if (kind == 'like') {
        param.rcmmCate = "RCMNVYTHNV00100"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.likeYn = 'Y';
      } else if (kind == 'report') {
        param.rcmmCate = "RCMNVYTHNV00200"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.reportValue = vm.insertVoiceReport.reportValue;
        if (vm.insertVoiceReport.reportValue == "RPTNVYTHNV00400") {
          param.reportEtcValue = vm.insertVoiceReport.reportEtcValue;
        }
      }

      Axios.post(url, {voiceVo: param}).then(function (response) {
        if (kind == 'like') {
          vm.viewModel.isLike = !vm.viewModel.isLike;
          if (vm.viewModel.reportList.length <= 2) { //length = 2 신고+추천
            vm.viewModel.reportList.push(param); //좋아요 시 여부 판단으로 url교체를 위한 준비작업
          }

          if (vm.viewModel.isLike) {
            vm.viewModel.detail.likeCnt++;
          } else {
            vm.viewModel.detail.likeCnt--;
          }
        } else if (kind == 'report') {
          if (response.data.succCnt > 0) {
            swal("등록되었습니다.").then(result => {
              window.location.reload();
            });
            return false;
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //공지사항/자료실 작성
    fnSetBoard: function (updateFlag) {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      if (validation.isEmpty(vm.insertVoice.title)) {
        swal("제목을 입력해주세요.");
        return false;
      } else if (!validation.isLength(vm.insertVoice.title, 0, 200)) {
        swal("제목이 너무 깁니다.");
        return false;
      } else if (validation.isEmpty(vm.insertVoice.content1)) {
        swal("내용을 입력해주세요.");
        return false;
      }

      let url = "/customer/voice/insertVoiceSuggest";
      let param = {};
      param.fileKey = $("#fileKey").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.updateFlag = updateFlag;
      param.title = vm.insertVoice.title;
      param.content1 = vm.insertVoice.content1;
      param.approve = "approve";
      if (updateFlag == "update") {
        param.brdUidKey = $("#paramUid").val();
        url = "/customer/voice/updateVoiceSuggest";
      }

      if ($("#type").val() == "file") {
        param.brdSubCtg = "BRDNVYTHNV00810"; //시민청원 자료실
      } else if ($("#type").val() == "notice") {
        param.brdCtg = "BRDNVYTHNV00100";
        param.brdSubCtg = "BRDNVSUBNV00300"; //시민청원 공지사항
      }

      vm.fnOnSwalAlert("등록", "등록하시겠습니까?",
        function () {
          Axios.post(url, {voiceVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '등록 완료',
                text: '등록이 완료되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    }
    /*============================================================ 저장 end ========================================================================*/,
    //댓글작성 초기화
    fnClearReply: function () {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //댓글작성 레이아웃 출력
    fnShowReplyWrite: function () {
      let vm = this;
      vm.viewModel.isReply = true;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //대댓글 작성 레이아웃 출력
    fnShowReReplyWrite: function (key) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = true;
      vm.viewModel.isReReplyUpt = false;
      vm.viewModel.currReplyUidKey = key;
    },
    //댓글 수정 값 세팅
    fnReplySetValue: function (vo) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;

      if (vo.replyDepth == 0) {
        vm.viewModel.isReplyUpt = true;
        vm.updateReplyModel.replyUidKey = vo.replyUidKey;
        vm.updateReplyModel.replyContent = vo.replyContent;
      } else if (vo.replyDepth == 1) {
        vm.viewModel.isReReplyUpt = true;
        vm.updateReReplyModel.replyUidKey = vo.replyUidKey;
        vm.updateReReplyModel.replyContent = vo.replyContent;
      }
    },
    //자료실,QnA 탭
    fnSwitchFileQnA: function (tabIdx) {
      let vm = this;
      if (tabIdx == 1) {
        vm.viewModel.isFileTab = true;
        vm.viewModel.isQnATab = false;
      } else if (tabIdx == 2) {
        vm.viewModel.isFileTab = false;
        vm.viewModel.isQnATab = true;
      }
    },
    //소개,공지사항,우수수상자 탭
    fnSwitchIntro: function (tabIdx) {
      let vm = this;
      if (tabIdx == 1) {
        vm.viewModel.isIntroTab = true;
        vm.viewModel.isNoticeTab = false;
        vm.viewModel.isExellentTab = false;
      } else if (tabIdx == 2) {
        vm.viewModel.isIntroTab = false;
        vm.viewModel.isNoticeTab = true;
        vm.viewModel.isExellentTab = false;
      } else if (tabIdx == 3) {
        vm.viewModel.isIntroTab = false;
        vm.viewModel.isNoticeTab = false;
        vm.viewModel.isExellentTab = true;
      }
    },
    //5개년도 세팅
    fnGetYearList: function () {
      let vm = this;
      let today = new Date();
      let year = today.getFullYear();
      for (let i = 0; i < 5; i++) {
        let yearObj = {yearValue: (year - i), yearName: (year - i) + "년도"};
        vm.viewModel.yearList.push(yearObj);
      }
    },
    //정책제안현황 탭 이동
    fnVoiceSuggestTab: function (tabIdx) {
      let vm = this;
      if (tabIdx == 1) { //정책제안
        vm.viewModel.isVoiceTab = true;
        vm.viewModel.isExellentTab = false;
        vm.viewModel.isLiveTab = false;
      } else if (tabIdx == 2) { //우수정책제안
        vm.viewModel.isVoiceTab = false;
        vm.viewModel.isExellentTab = true;
        vm.viewModel.isLiveTab = false;
        vm.fnGetVoiceSuggestList('likeCnt');
      } else if (tabIdx == 3) { //Live 정책제안
        vm.viewModel.isVoiceTab = false;
        vm.viewModel.isExellentTab = false;
        vm.viewModel.isLiveTab = true;
      }
    },
    //정렬기준 생성
    fnSetSortList: function (tabIdx) {
      let vm = this;
      vm.viewModel.sortList.push({"sortName": "최다 공감순", "sortValue": "likeCnt"});
      vm.viewModel.sortList.push({"sortName": "최다 조회순", "sortValue": "hit"});
      vm.viewModel.sortList.push({"sortName": "최근 공개순", "sortValue": "insertDate"});
    },
    //신고하기 레이아웃 출력
    fnShowReportWrite: function () {
      let vm = this;
      vm.viewModel.isReport = !vm.viewModel.isReport;
    },
    //공감한 사람 목록 출력
    fnShowLikeList: function (brdUidKey) {
      let vm = this;
      $("div .likeList").hide();
      $("div[data='" + brdUidKey + "']").show();
      vm.fnGetLikeList(brdUidKey);
    },
    //공감한 사람 목록 숨기기
    fnHideLikeList: function (brdUidKey) {
      $("div .likeList").hide();
    },
    //QnA 사용자 정보 세팅
    fnSetQnaUserDetail: function () {
      let vm = this;
      vm.insertVoiceQnA.name = $("#usrName").val();

      let usrPhone = $("#usrPhone").val();
      if (usrPhone != null && usrPhone != "") {
        vm.insertVoiceQnA.hp1 = usrPhone.substr(0, 3);
        vm.insertVoiceQnA.hp2 = usrPhone.substr(3, 4);
        vm.insertVoiceQnA.hp3 = usrPhone.substr(7, 4);
      }

      let usrEmail = $("#usrEmail").val();
      if (usrEmail != null && usrEmail != "") {
        vm.insertVoiceQnA.email1 = usrEmail.split("@")[0];
        vm.insertVoiceQnA.email2 = usrEmail.split("@")[1];
      }
    },
    //페이징 처리
    fnSetPager: function (totalCount, etc) {
      let vm = this;
      vm.viewModel.pager.etc = etc
      vm.viewModel.pager.totalSize = totalCount;
      vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
      Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
    },
    //swalalert 호출
    fnOnSwalAlert: function (title, content, callback) {
      let vm = this;
      swal({
        title: title,
        text: content,
        icon: vm.fnOnLoadSwalImageData('info'),
        buttons: true,
        dangerMode: true
      }).then(result => {
        if (result) {
          callback();
        } else {

        }
      });
    },
    //alert 이미지 호출
    fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    },
    //QnA 초기화
    fnClearQna: function () {
      let vm = this;
      vm.insertVoiceQnA.title = "";
      vm.insertVoiceQnA.content = "";
    },
    //에디터 사용
    onEditorChange: function (event) {
      this.insertVoice.content1 = event.html;
      this.$emit('getEditorInfo', event);
    }
    /*============================================================ 공유 start ========================================================================*/,
    fnOnClickSharePop: function () {
      this.isShare = true;
    },
    fnOnClickCloseSharePop: function () {
      this.isShare = false;
    },
    fnOnLoadKakaoContent: function (value) {
      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      if (_atag == null) {
        return '';
      }
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      if (_nbsptag == null) {
        return '';
      }
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");
      if (_httptag == null) {
        return '';
      }
      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;
    },

    fnOnClickKakaoShare: function () {
      let vm = this;
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = "http://localhost:8080"
        if (_pageName == 'voiceDetail') {
          _uri = urlAddress + '/customer/voice/voiceDetail?paramUid=' + _uidKey + '&shared=Y';
        } else if (_pageName == 'voiceBoardDetail') {
          _uri = urlAddress + '/customer/voice/voiceBoardDetail?paramUid=' + _uidKey + '&shared=Y';
        }

        vm.fnShareLog(_uidKey);

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateKakaoShareUrl(_uri,
          vm.viewModel.detail.title,
          _imgPath,
          '',
          '',
          '',
          '',
          ''
        );
      });


    },
    fnOnClickNaverShare: function () {
      let vm = this;
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'voiceDetail') {
          _uri = urlAddress + '/customer/voice/voiceDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'voiceBoardDetail') {
          _uri = urlAddress + '/customer/voice/voiceBoardDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateNaverShareUrl(_uri,
          vm.viewModel.detail.title,
          _imgPath
        );
      });

    },
    fnOnClickFacebookShare: function () {
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'voiceDetail') {
          _uri = urlAddress + '/customer/voice/voiceDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'voiceBoardDetail') {
          _uri = urlAddress + '/customer/voice/voiceBoardDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });

    },
    fnOnClickLinkShare: function () {
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'voiceDetail') {
          _uri = urlAddress + '/customer/voice/voiceDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'voiceBoardDetail') {
          _uri = urlAddress + '/customer/voice/voiceBoardDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);

        let popup_url = '/customer/activity/share/link';
        popup_url += '?url=' + encodeURIComponent(_uri);
        window.open(popup_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
      });

    },
    fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    },
    fnDeclareEnter: function (value) {
      let vm = this;

      if (vm.insertVoiceReport.reportValue.indexOf(value) > -1) {
        vm.insertVoiceReport.reportValue = "";
      } else {
        vm.insertVoiceReport.reportValue = value;
      }
    }
    /*============================================================ 공유 end ========================================================================*/
  }
});

